import { useField } from "formik";
import React, { useRef, useEffect }  from "react";
import { Form, InputGroup, Spinner } from "react-bootstrap";

import { joinClasses } from "../../helpers/utils";
import { usePrevious } from "../../hooks/utility";
import RequiredField from "./RequiredField";

export const ZipWithCheckField = ({
  label,
  classes,
  fieldRef,
  handleBlur,
  labelClassname,
  formGroupClasses,
  isRequired,
  noLabel,
  handleInvalidZip,
  checking,
  validate,
  ...props
}) => {
  const [field, meta] = useField({...props, validate});
  const zipFieldRef = useRef();
  const prevChecking = usePrevious(checking)

  useEffect(() => {
    if (!checking && prevChecking) {
      if (fieldRef && fieldRef.current) {
        fieldRef.current.focus()
      } else if (zipFieldRef && zipFieldRef.current) {
        zipFieldRef.current.focus()
      }
    }
  }, [checking, prevChecking, label, fieldRef])

  const FormLabel = <Form.Label className={labelClassname}>{label}</Form.Label>;
  const RequiredLabel = <RequiredField>{FormLabel}</RequiredField>;

  return (
    <Form.Group id={`form-group-${props.name}`} className={formGroupClasses}>
      {isRequired && !noLabel ? RequiredLabel : !noLabel && FormLabel}
      <InputGroup className={joinClasses(["input-group-merge", checking && "appended"])}>
        <Form.Control
          isInvalid={meta.touched && meta.error}
          className={joinClasses([classes, checking && "bg-light"])}
          ref={fieldRef || zipFieldRef}
          disabled={props.disabled || checking}
          {...field}
          {...props}
        />
        {checking && (
          <InputGroup.Append>
            <InputGroup.Text className={joinClasses(["px-18px", checking && "bg-light"])}>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                variant="secondary"
                aria-hidden="true"
              />
            </InputGroup.Text>
          </InputGroup.Append>
        )}
        {meta.touched && !!meta.error && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </InputGroup>
    </Form.Group>
  );
};

export default ZipWithCheckField;
